/* eslint-disable no-dupe-keys */
export default {
  evcs_trace: {
    name: '接口调用日志',
    // 属性（一般与对象内容匹配）
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      evcs_operator: '平台商',
      direction: '接口方向',
      api: '接口',
      params: '参数',
      created_at: '创建时间',
      operation: '操作',
      result: '结果'
    },
    // Enum的属性
    directions: {
      in: '第三方调用我方',
      out: '我方调用第三方'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_api: '请选择接口',
      search_keyword: '请求参数'
    },
    apis: {
      query_token: '查询 Token',
      query_station_status: '设备接口状态查询',
      query_equip_charge_status: '查询充电状态',
      query_stop_charge: '请求停止充电',
      query_terminal_code: '通过二维码查询枪号',
      notification_stationInfo: '推送充电站变化信息',
      query_start_print: '订单打印',
      parse_qrcode: '二维码解析',
      query_operator_list: '开放运营商查询',
      query_operator_info: '查询运营商信息',
      send_charge_record: '推送充电记录信息',
      query_stations_info: '查询充电站信息',
      query_station_stats: '查询统计信息',
      notification_stationStatus: '设备状态变化推送',
      query_equip_auth: '请求设备认证',
      query_equip_business_policy: '查询业务策略结果',
      query_start_charge: '请求启动充电',
      send_runing_info: '推送充电设备接口运行信息',
      notification_start_charge_result: '推送启动充电结果',
      query_start_charge: '请求启动充电',
      notify_order_payment_info: '支付成功通知',
      send_station_status: '推送充电设备接口状态',
      notification_equip_charge_status: '推送充电状态',
      notification_stop_charge_result: '推送停止充电信息',
      notification_charge_order_info: '推送充电订单信息',
      check_charge_orders: '推送订单对账结果信息',
      query_start_charge: '请求启动充电',
      check_charge_orders_reverse: '反向推送订单对账结果信息',
      supervise_notification_station_info: '推送充电站信息',
      supervise_notification_realtime_power_info: '推送充电站实时功率',
      supervise_notification_charge_order_info_history: '推送历史充电订单信息',
      supervise_notification_operation_stats_info: '推送充电站用能统计信息',
      supervise_notification_station_info: '推送充换电站信息',
      supervise_notification_equip_charge_status: '推送充电状态信息'
    },
    // 列表页
    index_page: {
      operation: '查看参数'
    },
    tips: {
      delete: '日志每分钟定时生成，每天凌晨3点会自动删除前3天的旧数据'
    }
  }
}
